import React from "react";
import ReactGA from "react-ga";
import {Redirect} from "react-router";
//import scrollToWithAnimation from "scrollto-with-animation";
import animateScrollTo from "animated-scroll-to";

import logo from "./../../images/wilson-ng-photography.png";
import "./../../css/header-menu.css";
//import logo from "./../../images/w.png"

const INACTIVE_MENU_CLASS = "hamburger hamburger-htx";
const ACTIVE_MENU_CLASS = "hamburger hamburger-htx is-active";
const HIDDEN_MENU_CLASS = "hidden";

export class HeaderMenuComponent extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            menuIconClass: INACTIVE_MENU_CLASS,
            menuDisplayClass: HIDDEN_MENU_CLASS
        };

        this.handleMenuIconClick = this.handleMenuIconClick.bind(this);
        this.handleMenuClick = this.handleMenuClick.bind(this);
        this.handleMobileMenuClick = this.handleMobileMenuClick.bind(this);
        this.handleBlogButtonClick = this.handleBlogButtonClick.bind(this);
    }

    handleMenuIconClick() {
        this.setState({
            menuIconClass: (this.state.menuIconClass === ACTIVE_MENU_CLASS)?INACTIVE_MENU_CLASS:ACTIVE_MENU_CLASS,
            menuDisplayClass: (this.state.menuDisplayClass === "")?HIDDEN_MENU_CLASS:""
        });
    }

    handleMenuClick(event) {
        let elemId = event.currentTarget.getAttribute("data-target");

        switch (elemId.toLowerCase()) {
          case "banner-component":
              window.history.replaceState({}, "Wilson Ng Photography", "/");
              break;

          case "about-component":
              window.history.replaceState({}, "Wilson Ng Photography", "/about");
              break;

          case "gallery-component":
              window.history.replaceState({}, "Wilson Ng Photography", "/gallery");
              break;

          case "contact-component":
              window.history.replaceState({}, "Wilson Ng Photography", "/contact");
              break;
        }
        // Tracking
        ReactGA.modalview(elemId.toLowerCase());

        // take care of Y offset scrolling
        let component = document.getElementById(elemId);
        let top = component.getBoundingClientRect().top;
        const y = window.pageYOffset;
        let offset = y + top;

        if (event.currentTarget.getAttribute("data-target") === "banner-component") {
            if (y === 0) return;
            offset = 0; // override
        } else {
            if (offset === 0) return;
        }

        const options = {
          // duration of the scroll per 1000px, default 500
          speed: 500,
          // minimum duration of the scroll
          minDuration: 1200,
          // maximum duration of the scroll
          maxDuration: 1500,
          // DOM element to scroll, default window
          // Pass a reference to a DOM object
          // Example: document.querySelector('#element-to-scroll'),
          element: window,
          // should animated scroll be canceled on user scroll/keypress
          // if set to "false" user input will be disabled until animated scroll is complete
          cancelOnUserAction: true,
          // function that will be executed when the scroll animation is finished
          onComplete: function() {}
        };

        animateScrollTo(offset, options);
        // scrollToWithAnimation(
        //     document.body,
        //     "scrollTop",
        //     offset,
        //     1500,
        //     "easeInOutCirc"
        // );
    }

    handleMobileMenuClick(event) {
        this.handleMenuIconClick();
        this.handleMenuClick(event);
    }

    handleBlogButtonClick() {
        // Tracking
        ReactGA.outboundLink({
            label: "menu-blog-button"
        }, function () {
            // no-op
        });

        var win = window.open("http://wilsonngphotography.blogspot.com/", "_blank");
        win.focus();
        //window.location = "http://wilsonngphotography.blogspot.com/";
    }

    render() {
        if (this.state.redirectTo) {
            return <Redirect push to={this.state.redirectTo} />;
        }

        const menuItems = [
//          {id: "services-section", text: "Services"},
          {id: "about-component", text: "About"},
          {id: "gallery-component", text: "Gallery"},
          {id: "contact-component", text: "Contact"}
        ];

        return (
            <section id="header-menu-component">
                <logo>
                    <img src={logo} alt="" data-target="banner-component" onClick={this.handleMenuClick}/>
                </logo>
                <nav>
                    <div id="menu-icon" className={this.state.menuIconClass} onClick={this.handleMenuIconClick}>
                        <span>&nbsp;</span>
                    </div>
                    <ul className={this.state.menuDisplayClass}>
                        <li><a href="javascript:void(0);" data-target="banner-component" onClick={this.handleMobileMenuClick}>Home</a></li>
                        {menuItems.map((item, index) => {
                                return <li key={index}><a href="javascript:void(0);" data-target={item.id} onClick={this.handleMobileMenuClick}>{item.text}</a></li>;
                            }
                        )}
                        <li>
                            <ReactGA.OutboundLink eventLabel="menu-blog-link" to="http://wilsonngphotography.blogspot.com/" target="_blank">
                                <span className="blog-link">Blog</span>
                            </ReactGA.OutboundLink>
                        </li>
                    </ul>
                    <div className="menu-bar">
                        <ul>
                            {menuItems.map((item, index) => {
                                    return <li key={index}><a href="javascript:void(0);" data-target={item.id} onClick={this.handleMenuClick}>{item.text}</a></li>;
                                }
                            )}
                        </ul>
                        <button className="hollow" onClick={this.handleBlogButtonClick}>Blog</button>
                    </div>
                </nav>
            </section>
        );
    }
}



// WEBPACK FOOTER //
// ./src/widgets/Scroll/HeaderMenuComponent.js